import request from 'superagent/lib/client';
import apiUrlProvider from './ApiURL';

function getCredentialsFromLocalStorage() {
    return JSON.parse(localStorage.getItem('scality-credentials')) || '';
}

export default {

    // List all policies
    getPolicies: (nbItems, marker) => {
        const credentials = getCredentialsFromLocalStorage();
        const markerParam = marker || '';

        return new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/iam/policies/` +
                `${nbItems}/${markerParam}`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // List policies attached to a group
    getGroupPolicies: (groupName, nbItems, marker) => {
        const credentials = getCredentialsFromLocalStorage();
        const markerParam = marker || '';

        return new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/iam/policies/group/` +
                `${groupName}/${nbItems}/${markerParam}`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Attach policy to group
    attachToGroup: (policyArn, groupName) => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/iam/policy/group/attach`)
                .set('x-access-token', credentials)
                .send({
                    policyArn,
                    groupName,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Detach policy from group
    detachFromGroup: (policyArn, groupName) => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/iam/policy/group/detach`)
                .set('x-access-token', credentials)
                .send({
                    policyArn,
                    groupName,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // List policies attached to a user
    getUserPolicies: (username, nbItems, marker) => {
        const credentials = getCredentialsFromLocalStorage();
        const markerParam = marker || '';

        return new Promise((resolve, reject) => {
            request
                .get(`${apiUrlProvider.apiUrl()}/iam/policies/user/` +
                `${username}/${nbItems}/${markerParam}`)
                .set('x-access-token', credentials)
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Attach policy to user
    attachToUser: (policyArn, userName) => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/iam/policy/user/attach`)
                .set('x-access-token', credentials)
                .send({
                    policyArn,
                    userName,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Detach policy from user
    detachFromUser: (policyArn, userName) => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/iam/policy/user/detach`)
                .set('x-access-token', credentials)
                .send({
                    policyArn,
                    userName,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },


    // Create a new policy
    createPolicy: (policyName, policyDocument) => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/iam/policy`)
                .set('x-access-token', credentials)
                .send({
                    policyName,
                    policyDocument,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Delete a policy
    deletePolicy: policyArn => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/iam/policy/delete`)
                .set('x-access-token', credentials)
                .send({
                    policyArn,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Get a policy version document
    getPolicyVersion: (policyArn, policyVersion) => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .post(`${apiUrlProvider.apiUrl()}/iam/getpolicyversion`)
                .set('x-access-token', credentials)
                .send({
                    policyArn,
                    policyVersion,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },

    // Update a policy
    updatePolicy: (policyArn, policyDocument) => {
        const credentials = getCredentialsFromLocalStorage();

        return new Promise((resolve, reject) => {
            request
                .put(`${apiUrlProvider.apiUrl()}/iam/policy`)
                .set('x-access-token', credentials)
                .send({
                    policyArn,
                    policyDocument,
                })
                .end((err, response) => {
                    if (err) {reject(err);}
                    resolve(JSON.parse(response.text));
                });
        });
    },


};



/** WEBPACK FOOTER **
 ** ./src/utils/PoliciesAPI.js
 **/